<template>
	<div class="destinations" >
		<t-destination-line v-if="order" type="dotted" class="top-line"/>
		<t-destination-dot :type="getDotType(from)" class="first-dot"/>
		<t-destination-line class="middle-line"/>
		<t-destination-dot :type="getDotType(to)" class="second-dot"/>
		<t-destination-line v-if="order" type="dotted" class="bottom-line"/>


		<div class="destinations-address" style="grid-row: 2/4; grid-column: 2;">
			<div class="destinations-address-name">
				{{ getProperty(from, 'name') }}
			</div>
			<div class="destinations-address-place">
				{{ getProperty(from, 'place') }}
			</div>
		</div>
		<div class="destinations-date" :class="{'actual-date': getProperty(from, 'actualDate') }" style="grid-row: 2; grid-column: 3;">{{fromDate}}</div>


		<div class="destinations-address" style="grid-row: 5/7; grid-column: 2;">
			<div class="destinations-address-name">
				{{ getProperty(to, 'name') }}
			</div>
			<div class="destinations-address-place">
				{{ getProperty(to, 'place') }}
			</div>
		</div>

		<div class="destinations-date" :class="{'actual-date': getProperty(to, 'actualDate') }" style="grid-row: 5; grid-column: 3;">{{toDate}}</div>
	</div>
</template>

<script>
export default {
	name: 'TDestinationsSmall',
	props: {
		from: Object,
		to: Object,
		order: { type: Boolean, default: false }
	},
	computed: {
		fromDate() {
			return this.getProperty(this.from, 'actualDate') || this.getProperty(this.from, 'estimatedDate');
		},
		toDate() {
			return this.getProperty(this.to, 'actualDate') || this.getProperty(this.to, 'estimatedDate');
		},
	},
	methods: {
		getProperty(object, propKey) {
			if (!object) return '';
			return object[propKey];
		},
		getDotType(destination) {
			if (!destination) return 'grey';
			else if (this.order && destination.actualDate) return 'green';
			else if (!this.order && destination.actualDate) return 'orange';
			else return 'grey';
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.first-dot, .second-dot, .top-line, .middle-line, .bottom-line {
	justify-self: center;
	grid-column: 1;
}

.first-dot, .second-dot {
	z-index: 2;
}

.top-line {
	grid-row: 1/3;
}

.first-dot {
	grid-row: 2/4;
}

.middle-line {
	grid-row: 3/6;
}

.second-dot {
	grid-row: 5/7;
}

.bottom-line {
	grid-row: 6/8;
}

.destinations {
	@extend %font-families-ui;
	height: 100%;
	display: grid;
	grid-template-columns: 30px 150px 40px;
	grid-template-rows: 6px 14px 14px 8px 14px 14px 4px;
	grid-column-gap: 5px;
	align-items: center;
	overflow: hidden;
}

.destinations-address {
	flex: 1;
}

.destinations-address-name {
	font-size: 12px;
	font-weight: 600;
	font-style: normal;
	font-stretch: normal;
	line-height: 1;
	letter-spacing: 0px;
	color: get-color($text, 'dark');
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.destinations-address-place {
	font-size: 10px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.6;
	letter-spacing: normal;
	color: get-color($text, 'dark');
}

.destinations-date {
	font-size: 10px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.6;
	letter-spacing: normal;
	text-align: right;
	color: get-color($text, 'light');
}

.actual-date {
	color: get-color($text, 'default');
	font-weight: 600;
}
</style>
<docs>
```jsx
<div style="width:240px">
<t-destinations-small :from="{name: 'Terminal Tiller', place: '7038 Tiller', date: '12.12'}"
		:to="{name: 'Terminal Ålesund', place: '6001 Ålesund', date: '20.12'}" />
</div>
```
</docs>